import axios from 'axios';

// --- CONFIGURAÇÃO DA URL BASE DA API ---
// A URL base da API é lida a partir das variáveis de ambiente do React.
// Isso permite alternar facilmente entre o ambiente de desenvolvimento (ex: http://127.0.0.1:8000/api)
// e o de produção (ex: https://api.gfp.btec.top/api).
// Se a variável não estiver definida, ele usa um valor padrão para desenvolvimento local.
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}`
  : process.env.REACT_APP_API_URL;

/**
 * @instance api
 * @description Instância do Axios pré-configurada para todas as chamadas à API do backend.
 * Centraliza a URL base e a lógica de autenticação.
 */
const api = axios.create({
  baseURL: API_BASE_URL,
});

// --- INTERCEPTOR DE REQUISIÇÃO ---
// O interceptor é uma função que o Axios executa ANTES de cada requisição ser enviada.
// É o local ideal para modificar a configuração da requisição, como adicionar cabeçalhos.
api.interceptors.request.use(
  (config) => {
    // Tenta obter o token de autenticação do localStorage.
    const token = localStorage.getItem('token');
    
    // Se um token for encontrado, ele é adicionado ao cabeçalho 'Authorization'.
    // O formato 'Bearer {token}' é o padrão para autenticação JWT (JSON Web Token).
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Retorna a configuração modificada para que a requisição possa continuar.
    return config;
  },
  (error) => {
    // Se ocorrer um erro durante a configuração da requisição, ele é rejeitado.
    return Promise.reject(error);
  }
);

export default api;
